import React, { useState, useEffect } from 'react';
import ShowGetImage from '../../common/components/ShowGetImage/ShowGetImage';

import PopUp from '../../common/components/PopUp/PopUp';
import { whatsAppReceiveDocAPI } from '../../common/constants/api';
import styles from './CMDashboard.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-light-svg-icons';
import Axios from 'axios';
const { whats_app_container } = styles;

const WhatsAppDoc = ({ leadId }) => {
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [dontClose, setDontClose] = useState(true);

  const [allImgUrl, setAllImgUrl] = useState([]);

  function whatsAppReceiveDocFun() {
    setType('loading');
    setText('Please wait while retrieving data...');
    setShow(true);
    setDontClose(true);
    whatsAppReceiveDocAPI(leadId)
      .then(res => {
        setAllImgUrl(res);
        setTimeout(() => {
          setShow(false);
        }, 2000);
        setDontClose(false);
      })
      .catch(err => {
        setShow(true);
        setDontClose(false);
        setType('fail');
        setText('something went wrong!');
      });
  }

  useEffect(() => {
    whatsAppReceiveDocFun();
  }, []);

  const download = (passUrl, imgType) => {
    let fileExtension = imgType.split('/').join('.');

    Axios(passUrl, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileExtension); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {});
  };

  return (
    <React.Fragment>
      <div>
        <div className="text-green-600 font-semibold text-base pt-3">
          Whats App Document
        </div>
        <div className={`${whats_app_container}`}>
          {allImgUrl &&
            allImgUrl?.map((each, i) => {
              return (
                <div className="bg-grey-1007 p-3 relative flex items-center justify-center border border-grey-1006 rounded border-dashed mt-3  w-40">
                  <ShowGetImage
                    key={i}
                    img={each?.attachmentUrl}
                    editBtn={false}
                    showInPopUP={true}
                    passStyle={{
                      width: '100px',
                      alignItems: 'center',
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      right: '7px',
                      bottom: '3px',
                      cursor: 'pointer'
                    }}
                  >
                    <div
                      href={each?.attachmentUrl}
                      download
                      onClick={e => {
                        e.stopPropagation();
                        download(each?.attachmentUrl, each?.attachmentFileType);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faDownload}
                        className="mr-1 text-xl "
                      />
                    </div>
                  </div>
                </div>
              );
            })}

          {!allImgUrl ||
            (allImgUrl.length == 0 && (
              <div className="font-roboto font-medium text-sm text-left mt-4 mb-10 text-black-0">
                No Data Available
              </div>
            ))}
        </div>
      </div>
      <PopUp
        type={type}
        text={text}
        setShow={setShow}
        show={show}
        dontClose={dontClose}
      />
    </React.Fragment>
  );
};

export default WhatsAppDoc;
